var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKey28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v28H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 2a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-2v2a1 1 0 0 1-.883.993L22 11h-2v2a1 1 0 0 1-.883.993L19 14h-2.556l.18.3a7.46 7.46 0 0 1 .969 3.371L17.6 18a7.5 7.5 0 1 1-5.78-7.301l.054.013 8.419-8.42a1 1 0 0 1 .576-.283L21 2zm-1 2h-2.586l-8.541 8.542a1 1 0 0 1-.904.274l-.12-.033a5.5 5.5 0 1 0 2.504 1.728 1 1 0 0 1 .064-1.341l.876-.877A1 1 0 0 1 16 12h2v-2a1 1 0 0 1 .883-.993L19 9h2V7a1 1 0 0 1 .883-.993L22 6h2V4zM8.5 18.2a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey28);
export default __webpack_public_path__ + "static/media/key_28.613f61d1.svg";
export { ForwardRef as ReactComponent };